<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                ></span>
                <type-text-box
                        v-model="ticket.value"
                        v-bind="[componentProps]"
                        :validation_settings="{}"
                        :type_attributes="'Single Line'"
                        :mode="'new'"
                        :type="'TextBox'"
                        @blur="signalChange"
                        :fieldAssignmentId="fieldAssignmentId+'-0'"
                        :label="innerLabel"
                ></type-text-box>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                {{ticket.value || 'N/A'}}
            </type-review>
        </div>
    </div>
</template>

<script>
    import formMixin from '../formMixin'
    import TypeReview from './TypeReview'
    import TypeTextBox from "./TypeTextBox";

export default {
    name: 'TypeAttributes',
    mixins: [formMixin],
    components: {
        TypeReview,
        TypeTextBox,
    },
    data() {
        return {
            ticket: {
                value:'',
                type:'',
            }
        }
    },
    async mounted() {
        if( !this.innerValue )
            this.innerValue = [];

        this.ticket.type = this.settings.ticket_type;

        this.getTicket();
        this.fieldLoaded(); // signal to the form we are loaded
    },
    watch: {
        innerValue() {
            this.getTicket();
        }
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                persistentHint: true
            }
        },
        rules() {
            return {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            }
        },
        ticketIndex() {
            return this.innerValue.findIndex(x => x.type == this.settings.ticket_type);
        }
    },
    methods: {
        getTicket() {
            this.ticket = this.ticketIndex > -1 ? this.innerValue[this.ticketIndex] : this.ticket;
        },
        signalChange() {
            if( this.ticket.type ) { // do not create empty tickets
                if (this.ticketIndex > -1)
                    this.innerValue[this.ticketIndex] = this.ticket;
                else
                    this.innerValue.push(this.ticket);

                this.innerValue = [...this.innerValue];
                this.$emit('input', this.innerValue);
            }
        },
    }
}
</script>

<style lang="scss">
    .v-time-picker-clock__hand, .v-time-picker-clock__item--active {
        background-color: #003e52 !important;
    }
</style>
